import {Directive, ElementRef, Input, TemplateRef, ViewContainerRef} from '@angular/core'
import {PERMISSION} from "@generated-backend-types";
import {UserSessionService} from '../services/user-session.service';
import {ModelPermission} from '../entities/model-permission.entity';

@Directive({
  selector: '[appIfHasAnyPermissions]',
  standalone: true
})
export class IfHasAnyPermissionDirective {
  public constructor(
    private readonly element: ElementRef,
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly authService: UserSessionService
  ) {}

  @Input() set appIfHasAnyPermissions(permissions: (PERMISSION|ModelPermission)[]) {
    if (permissions && permissions.length > 0 && this.authService.hasAnyPermission(permissions)) {
      this.viewContainer.createEmbeddedView(this.templateRef)
    } else {
      this.viewContainer.clear()
    }
  }
}
